import { render, staticRenderFns } from "./VignetteLogo.vue?vue&type=template&id=9ecf219c&scoped=true&"
import script from "./VignetteLogo.vue?vue&type=script&lang=ts&"
export * from "./VignetteLogo.vue?vue&type=script&lang=ts&"
import style0 from "./VignetteLogo.vue?vue&type=style&index=0&id=9ecf219c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9ecf219c",
  null
  
)

export default component.exports